export default "__VITE_ASSET__LYhsG$2N__"